import * as React from 'react';
import { Root, Trigger, Content } from '@radix-ui/react-collapsible';
import { useEffect } from 'react';
import { clsx } from 'clsx';

interface CollapsibleProps {
  triggerClassName?: string;
  contentClassName?: string;
  trigger?: React.ReactNode;
  content?: React.ReactNode;
  open?: boolean;
  disabled?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  children?: React.ReactNode;
}

export const Collapsible = React.forwardRef<HTMLDivElement, CollapsibleProps>(
  (
    {
      triggerClassName = '',
      contentClassName = '',
      trigger = null,
      content = null,
      open = false,
      disabled = false,
      onOpenChange: onOpenChangeProp,
      children,
      ...props
    },
    ref,
  ) => {
    const [openState, setOpenState] = React.useState(open);

    useEffect(() => {
      setOpenState(open);
    }, [open]);

    const onOpenChange = (isOpen: boolean) => {
      setOpenState(isOpen);
      onOpenChangeProp?.(isOpen);
    };

    return (
      <Root open={openState} onOpenChange={onOpenChange} disabled={disabled}>
        {trigger && <Trigger className={triggerClassName}>{trigger}</Trigger>}
        {children && (
          <Content className={clsx('CollapsibleContent', contentClassName)}>{children}</Content>
        )}
      </Root>
    );
  },
);
